import Hogan from "hogan.js";
import destinationSearch from "../../templates/desktop/destinationSearch.htm";
import detail from "../../templates/desktop/detail.htm";
import detailProductItem from "../../templates/desktop/detailProductItem.htm";
import detailMini from "../../templates/desktop/detailmini.htm";
import directionItem from "../../templates/desktop/directionItem.htm";
import directionRoadmapItem from "../../templates/desktop/directionRoadmapItem.htm";
import directionRoadmapRow from "../../templates/desktop/directionRoadmapRow.htm";
import directions from "../../templates/desktop/directions.htm";
import main from "../../templates/desktop/main.htm";
import map from "../../templates/desktop/map.htm";
import originSearch from "../../templates/desktop/originSearch.htm";
import quadrant from "../../templates/desktop/quadran.htm";
import resultItem from "../../templates/desktop/resultItem.htm";
import routeOriginSearch from "../../templates/desktop/routeOriginSearch.htm";
import search from "../../templates/desktop/search.htm";
import searchInputBottom from "../../templates/desktop/searchInputBottom.htm";
import searchInputTop from "../../templates/desktop/searchInputTop.htm";
import searchOnRoute from "../../templates/desktop/searchOnRoute.htm";
import sidePanel from "../../templates/desktop/sidePanel.htm";

export default {
    detail: Hogan.compile(detail),
    directionRoadmapItem: Hogan.compile(directionRoadmapItem),
    main: Hogan.compile(main),
    resultItem: Hogan.compile(resultItem),
    searchInputTop: Hogan.compile(searchInputTop),
    detailProductItem: Hogan.compile(detailProductItem),
    directionRoadmapRow: Hogan.compile(directionRoadmapRow),
    map: Hogan.compile(map),
    search: Hogan.compile(search),
    directionItem: Hogan.compile(directionItem),
    directions: Hogan.compile(directions),
    quadrant: Hogan.compile(quadrant),
    searchInputBottom: Hogan.compile(searchInputBottom),
    sidePanel: Hogan.compile(sidePanel),
    originSearch: Hogan.compile(originSearch),
    searchOnRoute: Hogan.compile(searchOnRoute),
    destinationSearch: Hogan.compile(destinationSearch),
    routeOriginSearch: Hogan.compile(routeOriginSearch),
    detailMini: Hogan.compile(detailMini),
};
